<template>
    <div id="galleryGrid" class="tchek-gallery__container">
        <template v-if="images.length > 0">
            <figure v-for="(image, key) in images" itemprop="associatedMedia" class="tchek-gallery__item" itemscope itemtype="http://schema.org/ImageObject" :key="key">
                <a ref="image" :data-index="key" :href="image.src" @click.prevent="$photoswipe.open($refs.image ,key, images)" itemprop="contentUrl">
                    <img class="tchek-gallery__img" :src="image.src" itemprop="thumbnail" :alt="'tchek image ' + key">
                </a>
            </figure>
        </template>
    </div>
</template>

<script>
import Vue from 'vue';
import VuePhotoSwipe from '../../../core/components/Photoswipe';
require('jquery');

Vue.use(VuePhotoSwipe);

export default {
    props: {
        tchekImages: {
            default: [],
            required: true,
        },
    },
    data() {
        return {
            firstImageSize: { width: 800, height: 600 } 
        };
    },
    methods: {
        getMeta(url) {
            return new Promise((resolve, reject) => {
                let img = new Image();
                img.onload = () => resolve({ width: img.width, height: img.height });
                img.onerror = () => reject(new Error(`Failed to load image: ${url}`));
                img.src = url;
            });
        },
        async fetchImageSize() {
            if (this.tchekImages.length > 0) {
                try {
                    this.firstImageSize = await this.getMeta(this.tchekImages[0].imageUrl || this.tchekImages[0].url);
                } catch (error) {
                    console.error("Error loading image metadata:", error);
                }
            }
        }
    },
    computed: {
        images() {
            return this.tchekImages.map(image => ({
                src: image.imageUrl || image.url,
                w: this.firstImageSize.width, 
                h: this.firstImageSize.height
            }));
        }
    },
    created() {
        this.fetchImageSize();
    }
}
</script>

<style lang="scss">
    .tchek-gallery__container {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
        gap: 10px;
    }

    .tchek-gallery__img {
        width: 100%;
        height: auto;
        object-fit: cover;
        border-radius: 4px;
    }

    .tchek-gallery__item{
        margin: 0rem;
    }
</style>